import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
//import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: "100%",
  },
  select: {
    //padding: '12px 15px',
    backgroundColor: '#fafafc',
    color: '#888',
    fontSize: '15px',  
    fontWeight: 'bold',
    outline: 'none',
    borderRadius: 0,
    border: '1px solid #eee !important',
    marginBottom: '15px',
    '&:hover': {
      border: '1px solid #eee',
    },
  }
}));

export function SelectComponent({
  form,
  list,
  name,
  value,
  label,
  handleChange,
  isMultiple,
  isRequired,
  className,
  valueKeyName,
  keyName,
  size,
  ...props
}) {
  const classes = useStyles();
  const lang = localStorage.getItem("lang") || "en";
  const renderMenuList = () => {
    return list?.map((item, index) => {
      return (
        <option
          key={index}
          value={valueKeyName ? item[valueKeyName] : item.value}
        >
          {keyName ? item[keyName] : item.content}
        </option>
      );
    });
  };

  return (
    <div>
      <FormControl
        size={size}
        variant="outlined"
        className={`my-3 ${classes.formControl} ${className ? className : ""}`}
      >
        <InputLabel className={form && classes.label}>
          {label}
          {isRequired && "*"}
        </InputLabel>
        <Select className={form && classes.select}
          name={name}
          value={value}
          onChange={handleChange}
          label={label}
          multiple={isMultiple}
          native={true}
          fullWidth
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom",
              horizontal: lang === 'ar' ? "right" : "left",
            },
            getContentAnchorEl: null
          }}
          {...props}
        >
          {renderMenuList()}
        </Select>
      </FormControl>
    </div>
  );
}
